// extracted by mini-css-extract-plugin
module.exports = {"otherTooltip":"otherTooltip_otherTooltip__4X_1l","fadeIn":"otherTooltip_fadeIn__jMLBS","left":"otherTooltip_left__bQKdR","right":"otherTooltip_right__3tzs6"};